import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FieldBody } from 'web-ui-components/lib/molecules/forms';
import { Label, Input } from 'web-ui-components/lib/atoms/forms';
import styles from './styles';
import { invalidBatchNameCharactersRegex } from '../../../config';
import { RenderPopper } from '../../../sharedComponents/RenderPopper/RenderPopper';

export const cleanBatchName = (batchName) => batchName.replace(invalidBatchNameCharactersRegex, '');

export class PaymentName extends Component {
	constructor(props) {
		super(props);
		this.state = {
			popovers: {},
			value: props.paymentName,
			isActive: false,
		};
		this.togglePopover = this.togglePopover.bind(this);
		this.handleOnBlur = this.handleOnBlur.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	togglePopover(key) {
		this.setState((state) => ({
			popovers: {
				[key]: !state.popovers[key],
			},
		}));
	}
	handleOnBlur() {
		const { value } = this.state;
		this.setState({ isActive: false });
		this.props.onBlur(value);
	}
	handleChange(event) {
		this.setState({
			value: cleanBatchName(event.target.value),
			isActive: true,
		});
	}
	render() {
		const { id, maxLength, description, label, labelSubText, paymentNamePopperText } = this.props;
		const { popovers, value, isActive } = this.state;
		return (
			<div>
				<Label className="u-type-size-uist" htmlFor="paymentName">
					{label}
				</Label>
				<RenderPopper
					id={id}
					content={paymentNamePopperText}
					isOpen={popovers.paymentName}
					togglePopover={this.togglePopover}
				/>
				<FieldBody>
					<Input
						type="text"
						id="batch-name"
						value={value}
						onBlur={this.handleOnBlur}
						onChange={this.handleChange}
						maxLength={maxLength}
					/>
				</FieldBody>
				{isActive && (
					<span id="importedPaymentNameToggledDescription" className={styles.main__description}>
						{description}
					</span>
				)}
				<p>{labelSubText}</p>
			</div>
		);
	}
}

PaymentName.propTypes = {
	id: PropTypes.string.isRequired,
	paymentName: PropTypes.string,
	onBlur: PropTypes.func.isRequired,
	maxLength: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	label: PropTypes.string,
	labelSubText: PropTypes.string,
	paymentNamePopperText: PropTypes.string,
};
